import script from "./SiteMail.vue?vue&type=script&lang=ts&setup=true"
export * from "./SiteMail.vue?vue&type=script&lang=ts&setup=true"

import "./SiteMail.vue?vue&type=style&index=0&id=0541b27c&lang=scss&scoped=true"

import exportComponent from "/opt/tiger/compile_path/src/code.byted.org/ad/se_tt4b_academy_advertiser_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0541b27c"]])

export default __exports__